import {
  AfterViewInit,
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { NotifierService } from 'angular-notifier';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';
import { BoobleModalService } from 'booble-modal';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { catchError, forkJoin, map, of } from 'rxjs';
import { OrdersService } from 'src/app/shared/services/orders.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { GenericBottomSheetComponent } from 'src/app/shared/components/generic-bottom-sheet/generic-bottom-sheet.component';
import { ContactDetailsComponent } from '../../modals/contact-details/contact-details.component';
import { ContactAccountDto } from 'src/app/domain/models/dto/contact-account.dto';

@Component({
  selector: 'app-contacts-mobile',
  templateUrl: './contacts-mobile.component.html',
  styleUrls: ['./contacts-mobile.component.scss'],
})
export class ContactsMobileComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input() data: ContactAccountDto[] = [];
  moedas = Moedas;
  private readonly notifier: NotifierService;

  pageIndex = 1;
  searchTerm: string = '';
  filteredItems: any[] = [];
  isMobile: boolean;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('bottomSheetContent') bottomSheetContent: TemplateRef<any>;

  pageSizeOptions = [3, 5, 10, 15, 25, 50];
  pageSize = 3;
  currentPage = 0;

  constructor(
    private modalService: BoobleModalService,
    private ordersService: OrdersService,
    private bottomSheet: MatBottomSheet,
    notifierService: NotifierService
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.isMobile = window.innerWidth <= 820;
    this.filteredItems = this.data;
    this.applyFilter();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.filteredItems = changes.data.currentValue;
      this.applyFilter();
    }
  }

  ngAfterViewInit() {
    this.paginator.page.subscribe(() => {
      this.currentPage = this.paginator.pageIndex;
    });
  }

  changePage(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
  }

  applyFilter() {
    const searchTermLower = this.searchTerm.toLowerCase();
    if (this.data.length > 0) {
      this.filteredItems = this.data.filter((item: ContactAccountDto) => {
        const name = item.senderReceiverName.toString().toLowerCase();
        const country = (item.country.description || '').toLowerCase();
        const currency = (item.currency.description || '').toLowerCase();

        return (
          name.indexOf(searchTermLower) !== -1 ||
          country.indexOf(searchTermLower) !== -1 ||
          currency.indexOf(searchTermLower) !== -1
        );
      });
    }
    //this.sortItemsById();
  }

  /*   sortItemsById() {
    this.filteredItems.sort(
      (a: InboundOrderDto, b: InboundOrderDto) => b.id - a.id
    );
  } */

  get totalPages(): number {
    return Math.ceil(this.filteredItems.length / this.pageSize);
  }

  getCurrencyDescription(currency: any): string {
    const moeda = this.moedas.find((m) => m.id === currency.id);
    return moeda?.description || currency.description;
  }

  get displayedItems(): any[] {
    if (this.filteredItems.length > 0) {
      const startIndex = this.currentPage * this.pageSize;
      const endIndex = startIndex + this.pageSize;
      return this.filteredItems?.slice(startIndex, endIndex);
    }
  }

  openContactDetailsModal() {
    if (this.isMobile) {
      this.openBottomSheet();
    } else {
      this.modalService.present(ContactDetailsComponent);
    }
  }

  openBottomSheet() {
    this.bottomSheet.open(GenericBottomSheetComponent, {
      data: { content: this.bottomSheetContent },
    });
  }
}
